import { PresentationMode } from '@/api/models/activity'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'

export const isTileView = (activityWithAggregate: FrontActivityWithAggregate | undefined | null) =>
  !!activityWithAggregate && activityWithAggregate.presentationMode === PresentationMode.Tiles
